module.exports = __webpack_public_path__ + "img/turtle.314db6cc.png";